'use client';

import { Divider, Pagination } from '@wishket/design-system';
import { Fragment, useEffect } from 'react';

import { useRouter } from 'next/navigation';

import ArticleItemWidget from '../ArticleItemWidget';
import { ArticleListSkeleton } from '../ArticleList';

import { SearchSectionTitle } from '@/features/Search';
import { useSearchArticleListQuery } from '@/entities/article';
import { useDeviceCheck } from '@/shared/hooks';
import { useSearchResult } from '@/shared/providers/SearchProvider';
import { PATH } from '@/shared/constants';

interface SearchedArticleListProps {
  searchQuery: string;
  page: number;
}

const SearchedArticleList = ({
  searchQuery,
  page,
}: SearchedArticleListProps) => {
  const { isDesktop } = useDeviceCheck();
  const { setIsArticleEmpty } = useSearchResult();
  const router = useRouter();

  const { data, isLoading } = useSearchArticleListQuery({
    query: searchQuery ?? '',
    page,
  });

  const changePage = (pageNumber: number) => {
    if (!window) return;
    const params = new URLSearchParams();

    params.set('q', searchQuery);
    params.set('page', pageNumber.toString());

    router.push(`${PATH.LIST_SEARCH}?${params.toString()}`);
  };

  useEffect(() => {
    setIsArticleEmpty(data?.articles.length === 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (!data) return <ArticleListSkeleton />;

  if (data?.articles.length === 0) return null;

  return (
    <>
      <SearchSectionTitle title="콘텐츠" count={data.count} />
      {data.articles.map((article, idx) => (
        <Fragment key={String(article.id)}>
          <ArticleItemWidget {...article} isVisibleCategory={true} />
          {idx < data.articles.length - 1 && <Divider isSub />}
        </Fragment>
      ))}
      <Pagination
        maxPage={data.maxPage}
        page={page}
        onChange={changePage}
        pageCount={isDesktop ? 10 : 5}
      />
    </>
  );
};

export default SearchedArticleList;
